import {
  ActionIcon as MantineActionIcon,
  type ActionIconProps as MantineActionIconProps,
  type MantineSize,
} from '@mantine/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export interface ActionIconProps extends MantineActionIconProps {
  icon?: IconDefinition
  iconSize?: MantineSize
  onClick: () => void
  'aria-label': string // required per style guide accessibility rules
}

export function ActionIcon({ icon, iconSize = 'md', onClick, ...props }: Readonly<ActionIconProps>) {
  return (
    <MantineActionIcon {...props} onClick={onClick}>
      {icon && <FontAwesomeIcon icon={icon} size={iconSize === 'sm' ? 'sm' : undefined} />}
    </MantineActionIcon>
  )
}
